import { ChevronDownIcon } from '@/components/ui/icon';
import { Select, SelectTrigger, SelectInput, SelectIcon, SelectPortal, SelectContent, SelectItem } from '@/components/ui/select';
import React from 'react';
import i18n from 'i18n-js';

export default function Selector({ title, selections, selected, setSelected }) {
    return (
        <Select accessibilityLabel={i18n.t(title)} variant="outline" onValueChange={(itemValue) => setSelected(itemValue)} className="max-w-[200px] bg-secondary-50">
            <SelectTrigger className="border border-secondary-900">
                <SelectInput fontSize="sm" placeholder={i18n.t(title)} value={i18n.t(selections[selected])} />
                <SelectIcon className="absolute right-3 text-secondary-900" as={ChevronDownIcon} />
            </SelectTrigger>
            <SelectPortal>
                <SelectContent>
                    {selections.map((key, k) => (
                        <SelectItem key={key} label={i18n.t(key)} value={k} />
                    ))}
                </SelectContent>
            </SelectPortal>
        </Select>
    );
}
